
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PricingPageHeader = () => {
  return (
    <div className="mb-8">
      <Link
        to="/"
        className="mb-8 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to home
      </Link>
      
      <div className="flex justify-center mb-6">
        <img 
          src="/lovable-uploads/29f5a874-3103-490e-ae29-e107bf621df9.png" 
          alt="Company Logo" 
          className="w-32 h-auto"
        />
      </div>
      <h1 className="text-center text-3xl font-bold tracking-tight mb-2">
        Request Pricing
      </h1>
      <p className="text-center text-muted-foreground">
        Please fill out your details below and we'll get back to you with pricing information.
      </p>
    </div>
  );
};

export default PricingPageHeader;
